<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :disabled="isdisableds"
      >
        <el-form-item label="捐赠项目：">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="捐赠方式：">
          {{ PayDetailType(dataForm.PayDetailType) }}
        </el-form-item>
        <el-form-item label="汇款凭证码：" v-if="dataForm.PayDetailType == 3">
          {{ dataForm.ReceiptNo }}
        </el-form-item> 
        <el-form-item label="付款凭证：" v-if="dataForm.PayDetailType == 3">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            :fileList="pictureList"
            :class="{ hideFile: true }"
          >
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item label="捐赠金额：" style="width: 7rem">
          {{ dataForm.Amount }}
        </el-form-item>
        <el-form-item label="捐赠者类型：">
          {{ Donation(dataForm.Donation) }}
        </el-form-item>
        <el-form-item label="捐赠者：">
          {{ dataForm.Name }}
        </el-form-item>
        <el-form-item label="电话号码：">
          {{ dataForm.Phone }}
        </el-form-item>
        <el-form-item label="捐赠时间：">
          {{ (dataForm.FinishTime * 1000) | formatDate }}
        </el-form-item>
        <!-- <el-form-item label="是否需要开具发票：">
          <el-radio-group v-model="dataForm.IsInvoiceStatus">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="是否开票据：" prop="IsInvoice">
          <div v-if="dataForm.IsInvoice">需要开具票据</div>
          <div v-else>不需要开具票据</div>
        </el-form-item>
        <!-- <el-form-item label="发票类型：" v-if="dataForm.IsInvoiceStatus===true">
          {{ isElectronicInvoice }}
        </el-form-item> -->
        <el-form-item label="捐赠留言：">
          {{ dataForm.Remark }}
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isConfirm: false,
      isdisableds: false,
      ishide: false,
      activeValue: 1,
      inactiveValue: 0,
      payTypeOptions: [
        { value: 1, label: "在线银联" },
        { value: 4, label: "微信支付" },
        { value: 5, label: "支付宝支付" },
        { value: 3, label: "线下转账" },
      ],
      donatorTypeOptions: [
        { value: 1, label: "个人" },
        { value: 2, label: "企业" },
      ],
      isInvoiceOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" },
      ],
      width: "50%",
      pictureList: [],
      hideUploadEdit: false,
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  computed: {
    //是否开具发票
    isInvoice: function () {
      return this.dataForm.IsInvoice ? 1 : 0;
    },
    isElectronicInvoice() {
      return this.dataForm.IsElectronicInvoice ? "电子票据" : "纸质票据";
    },
    PayDetailType() {
      return (data) => {
        for (var i = 0; i < this.payTypeOptions.length; i++) {
          if (data == this.payTypeOptions[i].value) {
            return this.payTypeOptions[i].label;
          }
        }
      };
    },
    Donation() {
      return (data) => {
        for (var i = 0; i < this.donatorTypeOptions.length; i++) {
          if (data == this.donatorTypeOptions[i].value) {
            return this.donatorTypeOptions[i].label;
          }
        }
      };
    },
  },
  mounted() {
    this.getImg();
  },
  components: {
    OfDialog,
    OfUpload,
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //初始化封面图
    getImg() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.hideUploadEdit = true;
      this.$http
        .get("/Sys/File/Download?Id=" + this.dataForm.File)
        .then((res) => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map((item) => {
            return {
              url: item.url,
            };
          });
        });
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.hideFile >>> .el-upload--picture-card {
  display: none !important;
}
.of-dialog >>> .el-button--primary {
  display: none;
}
.of-dialog >>> .el-button--default {
  display: none;
}
</style>
